import apiService from '../apiService';

import svcConfig from './demoConfig';

const demoService = {
  getDemoData: (request, urlParam) => {
    return apiService('getDemoData', svcConfig, request, urlParam);
  },
  saveDemoData: (request) => {
    return apiService('saveDemoData', svcConfig, request);
  },
};

export default demoService;
